<div class="row" *ngIf="offerConfiguration">
    <div class="col">
        <div class="d-flex justify-content-between align-items-baseline">
            <div>
                <h5 class="mb-0 mt-0">{{'OFFER_SETTINGS' | translate}}</h5>
                <span class="font-italic small mb-2 d-inline-block">{{'OFFER_SETTINGS_DESCRIPTION' | translate}}</span>
            </div>


            <button class="btn btn-default" style="font-size: 20px;" (click)="save()">
                <i ngbTooltip="{{'SAVE' | translate}}" class="fas fa-save"></i>
            </button>
        </div>

        <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-3">
                <lib-gung-text-input gungTranslate="OFFER_CONFIRMATION_SUBJECT"
                [(ngModel)]="offerConfiguration.offerSubject"
                [placeholder]="'Offer Received - #{offerId}'">
                </lib-gung-text-input>
                <span class="font-italic text-muted small mb-2 d-inline-block">
                    {{'OFFER_CONFIRMATION_SUBJECT_DESCRIPTION' | translate}}
                </span>
            </div>
        </div>

    </div>
</div>
